import React from "react";
import classNames from "classnames";
import * as styles from "./arrowIcon.module.scss";

const ArrowIcon = ({ direction = "left", className = "", isThin, ...props }) => {
  const rotationClass = {
    up: styles.rotateUp,
    right: styles.rotateRight,
    down: styles.rotateDown,
    left: styles.rotateLeft,
  }[direction];

  return (
    <svg
      className={classNames(styles.arrowIcon, rotationClass, className)}
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || 6}
      height={props.height || 10}
      viewBox="0 0 6 10"
      fill="none"
      {...props}
    >
      <path
        d="M5 1L1 5L5 9"
        stroke="#474F7B"
        strokeWidth={isThin ? 1 : 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowIcon;
